import { render, staticRenderFns } from "./Fund-News.vue?vue&type=template&id=7ca63d08&scoped=true&"
import script from "./Fund-News.vue?vue&type=script&lang=js&"
export * from "./Fund-News.vue?vue&type=script&lang=js&"
import style0 from "./Fund-News.vue?vue&type=style&index=0&id=7ca63d08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca63d08",
  null
  
)

export default component.exports